/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FacilityInnTypes } from './FacilityInnTypes';
import {
    FacilityInnTypesFromJSON,
    FacilityInnTypesFromJSONTyped,
    FacilityInnTypesToJSON,
    FacilityInnTypesToJSONTyped,
} from './FacilityInnTypes';

/**
 * 
 * @export
 * @interface EnabledPayer
 */
export interface EnabledPayer {
    /**
     * 
     */
    payor_id: string;
    /**
     * 
     */
    payer_type: EnabledPayerPayerTypeEnum;
    /**
     * 
     */
    inn_facilities: Array<FacilityInnTypes>;
}


/**
 * @export
 */
export const EnabledPayerPayerTypeEnum = {
    Standard: 'standard',
    Medicare: 'medicare',
    Medicaid: 'medicaid',
} as const;
export type EnabledPayerPayerTypeEnum = typeof EnabledPayerPayerTypeEnum[keyof typeof EnabledPayerPayerTypeEnum];


/**
 * Check if a given object implements the EnabledPayer interface.
 */
export function instanceOfEnabledPayer(value: object): value is EnabledPayer {
    if (!('payor_id' in value) || value['payor_id'] === undefined) return false;
    if (!('payer_type' in value) || value['payer_type'] === undefined) return false;
    if (!('inn_facilities' in value) || value['inn_facilities'] === undefined) return false;
    return true;
}

export function EnabledPayerFromJSON(json: any): EnabledPayer {
    return EnabledPayerFromJSONTyped(json, false);
}

export function EnabledPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnabledPayer {
    if (json == null) {
        return json;
    }
    return {
        
        'payor_id': json['payor_id'],
        'payer_type': json['payer_type'],
        'inn_facilities': ((json['inn_facilities'] as Array<any>).map(FacilityInnTypesFromJSON)),
    };
}

export function EnabledPayerToJSON(json: any): EnabledPayer {
    return EnabledPayerToJSONTyped(json, false);
}

export function EnabledPayerToJSONTyped(value?: EnabledPayer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payor_id': value['payor_id'],
        'payer_type': value['payer_type'],
        'inn_facilities': ((value['inn_facilities'] as Array<any>).map(FacilityInnTypesToJSON)),
    };
}

